import Dashboard from "./Dashboard";
import { useAuth } from "../../context/AuthContext";

export default function Admin() {
  const { user, access } = useAuth();

  return (
    <Dashboard
      user={user}
      access={access}
    />
  );
}